module.exports = __webpack_public_path__ + "7c07b4abbe1966e9bdf77a6937bccf7e.jpg";